export const faqList = [
    {
        q: '1.What is BlueRidgeBank?',
        a: 'BlueRidgeBank is a simple app that helps you save and invest with ease&safe. With BlueRidgeBank, you can earn interest income every day, even a small amount of money, but over time, it will be a very substantial income,And cultivate your financial awareness and habits.'
    },
    {
        q: '2.How do I start saving on BlueRidgeBank?',
        a: `To start saving on BlueRidgeBank:
• Visit the website and download the app to create an account.
• You can transfer money to your account from any Nigerian bank with a bank app .
• You can also add money to youraccount with most debit or credit cards.Enter your debit card details to activate your account and then make your first deposit. (You may use a MasterCard, Visa or Verve card from any Nigerian bank).
• Please remember：Savings Account Limit is ₦100,000`
    },
    {
        q: '3.Are there bank charges when you deduct from my account?',
        a: "No! it's completely FREE. There are no bank charges for transferring money to your BlueRidgeBank account."
    },
    {
        q: '4.How much can I start with?',
        a: `You can ONLY save between:
N100 – N100,000 per account Saving. The specific payment limit is restricted by different banks and payment methods,It is recommended that you investment amount within N50,000 per time.`
    },
    {
        q: '5.How safe is BlueRidgeBank?',
        a: `BN Supervision: Blue Ridge Microfinance Bank LTD is a microfinance bank supervised by the Central bank of Nigeria(CBN). We are engaged in legal and compliant financial activities in Nigeria, and we regularly submit corresponding product design and operation information to the CBN. Blue Ridge Bank APP is an important service method we provide to users. 
	Insurance Protection: According to the relevant laws and regulations of Nigerian bank financial management, we have purchased corresponding insurance for each user’s investment to protect your investment principal and interest from loss.
	Technical Guarantee: Our engineers come from world-renowned Internet companies and banks. They have rich experience in technology development. We use the most secure technology to protect your information from being misappropriated by criminals. These technologies include 256 bits SSL security encryption、AES encryption algorithm,etc.`
    },
    {
        q: '6.How can I contact with BlueRidgeBank',
        a: `Contact Number: 09087614130
Whatsapp: 09095055908
Email: help.blueridge@blueridgemfb.com`
    },
    {
        q: '7.Are my card details safe?',
        a: `Your security is our major priority, and we work with the world-renowned payment company OPay to process your card details.
Your card details are extremely safe and are warehoused where they can never be compromised.`
    },
    {
        q: '8.Can I increase my savings at anytime?',
        a: `Yes, you can increase the amount you're saving at anytime. Simply login and click 'Invest now', then edit the amount and use bank card to invest.`
    },
    {
        q: '9.How is interest calculated and paid',
        a: `Monthly Interest and pay.No matter how late, you can enjoy interest on the day the funds are transferred and invested successfully, and the interest will generally arrive after 8 o'clock the next day.The interest that arrives in the account is automatically included in the total investment, and you can earn interest on the next day (compound interest).`
    },
    {
        q: '10.Can I withdraw my savings at anytime?',
        a: `Yes, you can withdraw the amount you're saving at anytime. Simply login and click 'Account  Withdraw’, then edit the amount and bank account number.`
    },
    {
        q: '11.How long does it take for the withdrawal application to arrive?',
        a: `Deposit within 24-48 hours after successfully submitting the withdrawal application.`
    },
    {
        q: '12.What should I do if my account is not received 48 hours after the withdrawal application?',
        a: `If the withdrawal amount does not reach the bank account within 48 hours, the system will automatically unfreeze the withdrawal funds and restore them to your total assets account. You can log in to the APP to view the transaction records.
You can check whether the receiving bank account information (such as Name, BVN) has been modified recently, or transfer 1 amount of money to the account by other means, if you are sure that the bank account is normal and can receive payments normally (unfrozen, cancelled) , You can try to re-initiate the withdrawal application, or contact our customer service for help.
If your bank account is abnormal, you can use another bank account opened with your BVN to apply for withdrawal again.`
    },
    {
        q: '13.Is my interest income taxable',
        a: `Yes, in accordance with Nigerian law, we have withheld tax for you before paying your interest, which means that the interest you receive has already been taxed.
The current tax rate is 10% of your interest income. If the law is adjusted, we will also adjust it accordingly.`
    },
    {
        q: '14.What if I no longer have access to the phone number linked to my BVN?',
        a: `In a situation, where you no longer have access to the phone number linked to your BVN, kindly contact your bank to update the phone number.`
    },
    {
        q: '15.Do you give loans?',
        a: `Loan service is specially for high-quality saving users ! If you actively save and use on Blue Ridge Bank for 3 months at least, you will have a great chance of getting a loan!
Our online lending process is fully via the EaseMoni Mobile App.`
    },
    {
        q: '16.How to remove/delete saved debit cards?',
        a: `Steps to remove/delete saved cards on the app;
• Log in to the Blue Ridge banking app.
• Select the "Account" page
• Select the "Card" option
• Select the debit card/ATM card you want to remove/delete`
    }
]